exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2usWjnppDnQDtxPE1ZCokk {\n  padding: 0;\n}\n._2Xtj50tBU_hMdJax5o11Y4 {\n  min-height: 0 !important;\n  padding: 0 !important;\n  padding-inline: 0 !important;\n  padding-block: 0 !important;\n}\n._2Xtj50tBU_hMdJax5o11Y4 h1 {\n  padding-block: 0 !important;\n  min-height: 0 !important;\n}\n._1qSgbDEwkio8uU09cXP_5n {\n  margin-top: 12px;\n}\n._1M8KvST691fPZlvHyF9dSX {\n  overflow: auto;\n}\n", ""]);

// exports
exports.locals = {
	"retirementNotice": "_2usWjnppDnQDtxPE1ZCokk",
	"noPadding": "_2Xtj50tBU_hMdJax5o11Y4",
	"retirementClose": "_1qSgbDEwkio8uU09cXP_5n",
	"retirementNoticeContent": "_1M8KvST691fPZlvHyF9dSX"
};